module.exports = __webpack_public_path__ + "assets/0a12d6227033fdec0eda2a6d527073a8.mp3";